import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from 'react-router-dom';

import "../assets/scss/styles.scss";

import RouterSetting from "./router.setting";
import RouterMember from "./router.member";
import RouterBoard from "./router.board";
import RouterManage from "./router.manage";
import RouterProduct from "./router.product";
import RouterReserve from "./router.reserve";
import RouterPayment from "./router.payment";
import RouterRefund from "./router.refund";

import Dashboard from "../views/Dashboard";
import About from "../views/About";
import Login from "../views/page/member/Login";
import SessionStorage from '../utils/SessionStorage.utils';
import RequireAuth from './RequireAuth'; // RequireAuth

function Routers() {
  const pathName = useLocation().pathname;
  const [loginStatus, setLoginStatus] = useState(localStorage.getItem('isLoggedIn') === 'true');
  console.log('loginStatus', loginStatus)
  useEffect(() => {
    const verifyToken = async () => {
      const AccessToken = SessionStorage.getItemJsonParse("adminSession");
      // const RefreshToken = SessionStorage.getItemJsonParse("adminSession");
      if (AccessToken && AccessToken.accessToken) {
        try {
          console.log('token', AccessToken.accessToken)
          let base = process.env.REACT_APP_API_URL; // api 주소
          const response = await fetch(base + '/admin/token/refresh', {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${AccessToken.accessToken}`
            },
            body: JSON.stringify({ refresh: AccessToken.refreshToken })
          });
          if (response.ok) {
            setLoginStatus(true);
          } else {
            setLoginStatus(false);
          }
        } catch (error) {
          console.error('Token verification failed:', error);
          setLoginStatus(false);
        }
      }
    };

    verifyToken();
  }, []);
  return (
    <div className={`${pathName.includes("/Login") ? `` : `adm_com_container`
      }`}>
      <Routes>
        <Route exact path="/Login" element={<Login setLoginStatus={setLoginStatus} />} />

        {/* <Route exact path="/" element={<Dashboard />} /> */}
        {/* <Route exact path="/" element={<RouterMember />} /> */}
        <Route path="/" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterMember />
          </RequireAuth>
        } />
        <Route path="/Setting/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterSetting />
          </RequireAuth>
        } />
        <Route path="/Member/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterMember />
          </RequireAuth>
        } />
        <Route path="/Board/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterBoard />
          </RequireAuth>
        } />
        <Route path="/Manage/*" element={
          <RequireAuth chkLevel={1} chkDepth={3}>
            <RouterManage />
          </RequireAuth>
        } />
        {/* <Route exact path="/Setting/*" element={<RouterSetting />} />
        <Route exact path="/Member/*" element={<RouterMember />} /> */}
        <Route exact path="/about" element={<About />} />
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/Product/*" element={<RouterProduct />} />
        <Route exact path="/Reserve/*" element={<RouterReserve />} />
        {/* <Route exact path="/Board/*" element={<RouterBoard />} /> */}
        <Route exact path="/Payment/*" element={<RouterPayment />} />
        <Route exact path="/Refund/*" element={<RouterRefund />} />
        
      </Routes>
    </div>
  );
}

export default Routers;
